import clsx from "clsx";
import { ArrowLink } from "@/components/ui/ArrowLink";
import "./FeaturedCard.scss";
import { ComponentType, ReactNode } from "react";
import { SectionHeading } from "../Section";

type Image = {
  alt: string;
  src: string;
  title: string;
};

type CTAType = {
  label: string;
  href: string;
};

export enum FeaturedCardFormatType {
  LANDSCAPE = "landscape",
  SQUARE = "square",
}

type FeaturedCardProps = {
  sectionTitle?: string;
  cardTitle: string;
  image?: Image;
  description?: string | ReactNode;
  cta: CTAType;
  cardFormat?: FeaturedCardFormatType;
  asLink?: "a" | ComponentType<any>;
  asImage?: "img" | ComponentType<any>;
};

export const FeaturedCard = ({
  sectionTitle = "",
  cardTitle = "",
  image,
  description = "",
  cta,
  cardFormat = FeaturedCardFormatType.LANDSCAPE,
  asLink = "a",
  asImage = "img",
}: FeaturedCardProps) => {
  const ImageComponent = asImage;
  const LinkComponent = asLink;

  return (
    <section className="ui-featured-card-section">
      <SectionHeading
        className="ui-featured-card-section-title"
        title={sectionTitle}
        titleMarginBottom="0"
      />
      <div
        className={clsx(
          "ui-featured-card",
          cardFormat === FeaturedCardFormatType.LANDSCAPE
            ? "ui-featured-card-landscape"
            : "ui-featured-card-square",
        )}
      >
        {image?.src && (
          <div className="ui-featured-card-image">
            <ImageComponent
              src={image?.src}
              alt={image?.alt}
              title={image?.title}
            />
          </div>
        )}
        <div className="ui-featured-card-content">
          <h3
            className={clsx(
              "cursor-pointer hover-underline ui-featured-card-title",
            )}
          >
            <LinkComponent className="link-unstyled" href={cta.href}>
              {cardTitle}
            </LinkComponent>
          </h3>
          <p
            className={clsx(
              "fs-6 flex-1 md-fs-custom text-slate-20 ui-featured-card-description",
            )}
          >
            <LinkComponent className="link-unstyled" href={cta.href}>
              {description}
            </LinkComponent>
          </p>
          <div className="ui-featured-card-cta">
            <ArrowLink href={cta.href ?? "#"} asLink={asLink}>
              {cta.label?.toUpperCase()}
            </ArrowLink>
          </div>
        </div>
      </div>
    </section>
  );
};
